import { createUseStyles } from "react-jss";
import {colors} from "../../constants/colors";
import {breakpoints} from "../../constants/breakpoints";

const styles = createUseStyles({
  settings: {
    //
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    margin: "0px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "20px",
    },
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0 0 0 12px",
    marginTop: "4px",
    marginBottom: 0,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginBottom: "15px",
    },
  },
  container:{
    margin: 0,
    padding: "0 0 24px 0px",
    maxWidth:"100%",
  },
  bannerWrapper: {
    display: "flex",
    marginBottom: "32px",
    gap: "16px",
    padding: "16px",
    border: "1px solid" + colors.gray300,
    borderRadius: "12px",
    "& svg": {
      flexShrink: "0",
    },
    "& h6": {
      marginBottom: "4px",
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "20px",
      color: colors.gray700,
    },
    "& p": {
      margin: "0px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.choiceGray600,
    },
  }
});

export default styles;
